import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { MoodboardsView } from '~/components/moodboards/moodboards-view'
import { titleFor } from '~/lib/route-title'
import { useWorkspace } from '~/lib/workspace-context'

/**
 * The workspace's own moodboards — the ones that belong to no project (folha
 * 04, D5): a palette the studio likes, a supplier it is testing. A project's
 * boards live on its Moodboards tab instead.
 */
const RouteComponent = () => {
  const { t } = useLingui()
  const workspace = useWorkspace()
  const navigate = useNavigate()
  const { board } = Route.useSearch()
  const { workspaceSlug } = Route.useParams()

  return (
    <div className="h-full">
      <MoodboardsView
        moodboardId={board}
        onOpen={(next) =>
          navigate({
            params: { workspaceSlug },
            replace: true,
            search: { board: next },
            to: '/$workspaceSlug/moodboards',
          })
        }
        title={t`Moodboards`}
        workspaceId={workspace._id}
      />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/moodboards')({
  component: RouteComponent,
  head: () => ({ meta: [{ title: titleFor(msg`Moodboards`) }] }),
  validateSearch: (search: Record<string, unknown>): { board?: string } => ({
    board: typeof search.board === 'string' ? search.board : undefined,
  }),
})
